import Storage from 'utils/localStorage/Storage';
import userUtils from 'utils/User';
import BeyondIdentityUtils from 'utils/BeyondIdentity';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import { MAX_TOTAL_DISMISSALS, FOURTEEN_DAYS_MS } from 'constants/passkeys';
import passkeysActions from 'actions/PasskeysActions';

const getTrackingData = () => {
    return Storage.local.getItem(LOCAL_STORAGE.PASSKEY_OPTIN_TRACKING) || {};
};

const isPasskeySupported = async () => {
    if (!window.PublicKeyCredential) {
        return false;
    }

    try {
        return await window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable();
    } catch (error) {
        return false;
    }
};

const getDevicePasskeys = async () => {
    try {
        const currentEmail = userUtils.getProfileEmail();
        const devicePasskeys = await BeyondIdentityUtils.getPasskeys();
        const devicePasskey = devicePasskeys.find(passkey => passkey?.identity?.emailAddress === currentEmail);

        return devicePasskey;
    } catch (error) {
        return [];
    }
};

const doesDevicePasskeyExistInAllPasskeys = (allPasskeys, devicePasskey) => {
    try {
        const existsInAllPasskeys = allPasskeys.some(
            passkey => passkey.passkeyId === devicePasskey.passkeyId && passkey.identityId === devicePasskey.identity.id
        );

        return existsInAllPasskeys;
    } catch (error) {
        return false;
    }
};

const isPasskeyExistsInCurrentDevice = async (passkeys = [], isLoadedPasskeys = false) => {
    try {
        const devicePasskey = await getDevicePasskeys();
        const allPasskeys = isLoadedPasskeys ? passkeys : await passkeysActions.getPasskeysData();

        if (!devicePasskey) {
            return false;
        }

        const existsInAllPasskeys = doesDevicePasskeyExistInAllPasskeys(allPasskeys, devicePasskey);

        if (!existsInAllPasskeys) {
            BeyondIdentityUtils.deletePasskey(devicePasskey.id);
        }

        return existsInAllPasskeys ? devicePasskey.passkeyId : false;
    } catch (error) {
        return false;
    }
};

const isPasskeyDisabled = async isEnabledEntryFlag => {
    const isSupported = await isPasskeySupported();

    return !Sephora.configurationSettings?.passkey?.isPasskeyEnabled || !isSupported || !isEnabledEntryFlag;
};

const resetTracking = () => {
    Storage.local.removeItem(LOCAL_STORAGE.PASSKEY_OPTIN_TRACKING);
    const dismissedCount = Storage.local.getItem(LOCAL_STORAGE.PASSKEY_OPTIN_DISMISSED) || {};
    const count = (dismissedCount.count || 0) + 1;
    Storage.local.setItem(LOCAL_STORAGE.PASSKEY_OPTIN_DISMISSED, { count });
};

const trackDismissal = () => {
    let trackingData = getTrackingData();

    // Initialize tracking if not exists
    if (!trackingData?.count) {
        trackingData = { count: 0, lastDismissed: null, pauseUntil: null };
    }

    // Increment count
    trackingData.count += 1;
    trackingData.lastDismissed = new Date().getTime();

    if (trackingData.count >= MAX_TOTAL_DISMISSALS) {
        // Set 14-day pause
        trackingData.pauseUntil = new Date().getTime() + FOURTEEN_DAYS_MS;
    }

    Storage.local.setItem(LOCAL_STORAGE.PASSKEY_OPTIN_TRACKING, trackingData);
};

export default {
    isPasskeyDisabled,
    resetTracking,
    getTrackingData,
    trackDismissal,
    isPasskeyExistsInCurrentDevice
};
